import { DateTime } from 'luxon';
import { ButtonLink } from '../../../../GlobalComponents/ButtonLink';
import { Flex } from '../../../../GlobalComponents/Flex';
import { useGetStoreQuery } from '../../../graphql';
import { OrderHistoryItems } from '../components/OrderHistoryItems';
import {
	Address1,
	CityStateZip,
	Container,
	OrderDate,
	PlacedText,
	TitleContainer,
	TotalCost,
	OrderStatus
} from '../components/OrderHistoryStyled';
interface IOrderItems {
	item: {
		item_id: number;
		product: {
			name: string;
			product_id: string;
		};
	};
}

interface OrderCardProps {
	orderNumber: string;
	total: number;
	date: string;
	storeId: string;
	orderItems: Array<IOrderItems>;
	status: string;
}

const OrderCard: React.FC<OrderCardProps> = ({
	orderNumber,
	total,
	date,
	storeId,
	orderItems,
	status
}): JSX.Element => {
	const handlePrice = (price: number) => {
		const result = (price / 100).toFixed(2);
		return result;
	};

	const readOrderStatus = (status: string) => {
		let orderStatus;
		switch (status) {
			case 'ORDER_SENT':
				orderStatus = 'Order Placed';
				break;
			case 'ORDER_READY':
				orderStatus = 'Ready for Pickup';
				break;
			case 'ORDER_COMPLETE':
				orderStatus = 'Order Completed';
				break;
			case 'ORDER_PROCESSING':
				break;
			case 'ORDER_REFUND_PROCESSED':
				orderStatus = 'Refunded';
				break;
			case 'ORDER_REFUND_REQUESTED':
				orderStatus = 'Refund Requested';
				break;
			case 'ORDER_ERROR':
				orderStatus = 'Status Unknown';
				break;
			default:
				orderStatus = 'Status Unknown';
		}
		return orderStatus;
	};

	const orderStatus = readOrderStatus(status);
	const RenderAddressInfo = (storeNumber: string) => {
		const snumber = parseInt(storeNumber);
		const { data } = useGetStoreQuery({
			variables: { storeId: snumber }
		});
		const zipState = data?.store.zipCode;
		const stateState = data?.store.state;
		const cityState = data?.store.city;
		const address1state = data?.store.address1;

		return (
			<>
				{data && (
					<>
						<Address1>{address1state}</Address1>
						<CityStateZip>
							{cityState}, {stateState}, {zipState}
						</CityStateZip>
					</>
				)}
			</>
		);
	};

	const orderDate = DateTime.fromISO(date).toFormat('MMMM d, yyyy');
	return (
		<Container>
			<Flex $flexDirection="row" $alignItems="flex-start">
				<TitleContainer>
					<OrderDate>Ordered: {orderDate}</OrderDate>
				</TitleContainer>

				<OrderStatus>{orderStatus}</OrderStatus>
			</Flex>

			<Flex $flexDirection="row" $alignItems="center">
				<Flex $flexDirection="column" $rowGap="24px">
					<Flex
						$flexDirection="row"
						$flexWrap="wrap"
						$columnGap="12px"
						$rowGap="12px"
					>
						{orderItems.map(el => (
							<OrderHistoryItems
								key={el.item.product.product_id}
								product={{
									id: el.item.product.product_id,
									name: el.item.product.name
								}}
							></OrderHistoryItems>
						))}
					</Flex>
					<Flex $flexDirection="row" $alignItems="flex-end">
						<Flex $flexDirection="column">
							<TotalCost>${handlePrice(total)}</TotalCost>
							<PlacedText>Placed At:</PlacedText>
							{RenderAddressInfo(storeId)}
						</Flex>

						<ButtonLink
							to={`/account/orders/${orderNumber}`}
							$minWidth="100px"
						>
							Details
						</ButtonLink>
					</Flex>
				</Flex>
			</Flex>
		</Container>
	);
};

export default OrderCard;
